import { render } from "./App.vue?vue&type=template&id=b45719ce&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=b45719ce&lang=css"
import "./App.vue?vue&type=style&index=1&id=b45719ce&scoped=true&lang=css"

import exportComponent from "D:\\Users\\User\\Documents\\_PROJECTS\\VUE.JS\\tulmash\\web_widgets\\calc_conveyor\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b45719ce"]])

export default __exports__